exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NotificationDropdown__badge_dot--3BmZN {\n  opacity: 0.9;\n  position: absolute !important;\n  top: 0 !important;\n  right: 0;\n  transform: translate(-2px, 22px);\n  transform-origin: 100% 0%;\n  z-index: 1;\n  width: 6px;\n  height: 6px;\n  background: var(--red-6);\n  border-radius: 100%;\n  box-shadow: 0 0 0 2px var(--gray-10); }\n", ""]);

// exports
exports.locals = {
	"badge_dot": "NotificationDropdown__badge_dot--3BmZN"
};